export const UPDATE_DATASETS = 'UPDATE_DATASETS'
export const UPDATE_DATASET_PAGINATION = 'UPDATE_DATASET_PAGINATION'
export const UPDATE_DATASET_SEARCH_TERM = 'UPDATE_DATASET_SEARCH_TERM'
export const UPDATE_DATASET_DESCRIPTION = 'UPDATE_DATASET_DESCRIPTION'
